export interface Category_data {
    imgurl : string;
}

let category_data :Category_data[] = [
    {
        imgurl : './img/category/category0.png'
    },
    {
        imgurl : './img/category/category1.png'
    },
    {
        imgurl : './img/category/category2.png'
    },
    {
        imgurl : './img/category/category3.png'
    },
    {
        imgurl : './img/category/category4.png'
    },
    {
        imgurl : './img/category/category5.png'
    },
    {
        imgurl : './img/category/category6.png'
    },
    {
        imgurl : './img/category/category7.png'
    }
]

export default category_data;